<!-- src/components/PayDetail.vue -->
<template>
  <div>
    <!-- Header -->
   <div class="p-4 border-b flex justify-between items-center">
      <h2 class="text-xl font-bold">PAY DETAIL REPORT
        <button @click="emit('close')" class="text-gray-500 hover:text-gray-700 text-right">&times;</button>
        </h2>
    </div>

    <!-- Body -->
    <div class="p-6">
      <div class="mb-4">
        <p class="text-lg">
          <span class="font-semibold">Pay Detail For Employee:</span>
          <span class="text-blue-600">{{ employeeName || 'TBC' }}</span>
        </p>
        <p class="text-lg">
          <span class="font-semibold">Total Pay:</span>
          <span class="text-green-600 font-bold">£{{ totalPay || '0.00' }}</span>
        </p>
      </div>

      <!-- Table -->
      <div class="overflow-x-auto">
        <table class="border-collapse border text-sm mx-auto">
          <thead>
            <tr class="bg-gray-100">
              <th class="border p-2">Site Name</th>
              <th class="border p-2">Job Date</th>
              <th class="border p-2">Start Time</th>
              <th class="border p-2">End Time</th>
              <th class="border p-2">Hours</th>
              <th class="border p-2">Rate</th>
              <th class="border p-2">+/-</th>
              <th class="border p-2">Remarks</th>
              <th class="border p-2">B. Hrs.</th>
              <th class="border p-2">Net Hrs.</th>
              <th class="border p-2">T. Exp.</th>
              <!--th class="border p-2">Print</th-->
            </tr>
          </thead>
          <tbody>
            <tr v-if="!payDetails || payDetails.length === 0">
              <td colspan="12" class="border p-4 text-center text-gray-500">No records found</td>
            </tr>
            <tr v-for="(row, index) in payDetails" :key="index">
              <td class="border p-2">{{ row.siteInfo || row.siteName || '-' }}</td>
              <td class="border p-2">{{ formatDate(row.jobDate) }}</td>
              <td class="border p-2">{{ row.startTime || '-' }}</td>
              <td class="border p-2">{{ row.endTime || '-' }}</td>
              <td class="border p-2">{{ row.dutyHours || '-' }}</td>
              <td class="border p-2">{{ row.payRate || row.rate || '-' }}</td>
              <td class="border p-2">{{ row.adjustment || row.adjustmentHours || '-' }}</td>
              <td class="border p-2">{{ row.remarks || '-' }}</td>
              <td class="border p-2">{{ row.bonusHours || '-' }}</td>
              <td class="border p-2">{{ row.netHours || '-' }}</td>
              <td class="border p-2">{{ row.travelExpense || '-' }}</td>
              <!--td class="border p-2">
                <button @click="printRow(row)" class="text-blue-600 hover:underline cursor-pointer">Print</button>
              </td-->
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="12" class="border p-2 text-right font-semibold">
                Total Hours = <span class="text-blue-600">{{ totalHours }}</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

type Job = {
  siteInfo?: string
  siteName?: string
  jobDate?: string
  startTime?: string
  endTime?: string
  hours?: number
  totalHours?: number
  payRate?: number
  rate?: number
  adjustment?: number
  adjustmentHours?: number
  remarks?: string
  bonusHours?: number
  netHours?: number
  travelExpense?: number
}

const props = defineProps<{ baseUrl: string; payId: string | number }>()
const emit = defineEmits<{ (e: 'close'): void }>()

const payDetails = ref<Job[]>([])
const employeeName = ref('TBC')
const totalPay = ref(0)
const totalHours = ref(0)

const formatDate = (dateStr?: string) => dateStr ? new Date(dateStr).toLocaleDateString('en-GB') : '-'

const printRow = (row: Job) => alert(`Printing: ${row.siteInfo || row.siteName}`)

const fetchPayDetail = async () => {
  try {
    const res = await fetch(`${props.baseUrl}Pays/ShowPayDetail/${props.payId}`, {
      headers: { "Authorization": `Bearer ${localStorage.token}` }
    })
    if (!res.ok) throw new Error(await res.text())
    const data = await res.json()

    //console.log("data for paydetail : ", data)

    if (data.pays && Array.isArray(data.pays.jobs)) {
      payDetails.value = data.pays.jobs;
      totalPay.value = data.pays.totalPay || 0;
      totalHours.value = data.pays.totalHoursForPay || 0;
      employeeName.value = data.pays.employeeName || 'TBC';
    } else if (Array.isArray(data)) {
      payDetails.value = data
      totalPay.value = 0
      totalHours.value = 0
    } else {
      employeeName.value = data.pays.employeeName || 'TBC'
      totalPay.value = data.totalPay || 0
      totalHours.value = data.pays.totalHoursForPay || 0
      payDetails.value = data.payDetails || data.jobs || []
    }
  } catch (e) {
    alert('Failed to load: ' + (e instanceof Error ? e.message : 'Unknown error'))
  }
}

onMounted(fetchPayDetail)
</script>